// 利用者一覧用フィールド
import * as React from 'react';
import * as UserListField from '../constants/UserListField';
import * as PropTypes from 'prop-types';
import { Doctor, Patient, Hospital } from '../interfaces';
// import { calcAge } from '../utils/commonUtil';
// import * as MoffCheckConst from '../constants/MoffCheck';
// import * as InterestCheckConst from '../constants/InterestCheck';

export enum Type {
  // 医師一覧
  Doctor,
  // 患者一覧
  Patient,
  // 医療機関一覧
  Hospital
}

// 利用者一覧の表のヘッダー部分.
export const userListHeader = Object.keys(UserListField.DefaultFieldModel).map((key) => {
  return (
    <th key={key} scope="col">{UserListField.DefaultFieldModel[key]}</th>
  );
});

export const doctorListHeader = Object.keys(UserListField.doctorHeader).map(key => {
  return (
    <th key={key} scope="col">{UserListField.doctorHeader[key]}</th>
  );
});

export const patientHeader =  Object.keys(UserListField.patientHeader).map((key) => {
  return (
    <th key={key} scope="col">{UserListField.patientHeader[key]}</th>
  );
});
export const hospitalHeader =  Object.keys(UserListField.hospitalHeader).map((key) => {
  return (
    <th key={key} scope="col">{UserListField.hospitalHeader[key]}</th>
  );
});

export let checkedUserIds: any[];

interface UserSelectBodyProps extends React.Props<{}> {
  patients?: Patient[];
  doctors?: Doctor[];
  hospitals?: Hospital[];
  type: Type;
  checkedUserIds: any[];
  moffAPI: any;
  moffAPIActions: any;
  download: boolean;
}

// 利用者一覧の表のフィールド表示用コンポーネント
export class UserSelectBody extends React.Component<UserSelectBodyProps, {}> {
  urlBase: string;
  btnText: string;

  // あとから日付を入れるための仕組み.
  refElements: HTMLElement[] = [];

  /**
   * render()直前の処理.
   *
   * @memberof UserSelectBody
   */
  componentWillMount() {
    switch (this.props.type) {
      case Type.Doctor:
        this.urlBase = '/doctor';
        // this.runAPI(Type.Doctor);
        break;
      case Type.Patient:
        this.urlBase = '/patient';
        break;
      case Type.Hospital:
        this.urlBase = '/hospital';
        break;
      default:
        break;
    }
    checkedUserIds = [];
  }

  /**
   *
   *
   * @readonly
   * @static
   * @memberof UserSelectBody
   */
  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  /**
   * コンポーネントマウント後.
   *
   * @returns
   * @memberof UserSelectBody
   */
  componentDidMount() {
    // 個別機能訓練に関する記録のときは曜日で行うがそれ以外は何もしない.
    // if (this.props.type !== Type.Kiroku) {
    //   return;
    // }

    // 個別機能訓練に関する記録のときの本日の曜日の処理.
    // const todayDay: string = UserListField.WEEK_CHARS[new Date().getDay()];

    // // デフォルトはその曜日なのでそれでinexを取得する.
    // const weekSelected: string = todayDay;

    // // userのオブジェクトの入ったhiddenのClass.
    // let usersObject: HTMLCollectionOf<Element> = document.getElementsByClassName('user');
    // // ここから曜日フィルター.
    // let index: number = 0;
    // for (const key in usersObject) {
    //   if (usersObject.hasOwnProperty(key)) {
    //     // 1つのエレメント.
    //     const element: Element = usersObject[key];

    //     // stringfyで入ってるのでいったん変換.
    //     const userVisitDay: number[] = (JSON.parse(element.innerHTML) as UserListField.User).user_visit_day;

    //     const parent: HTMLElement | null = element.parentElement;
    //     // 選択されたWeekSelectedがWeekChars[]の中では何番目の値なのか？
    //     const weekIndex = UserListField.START_MO_WEEK_CHARS.indexOf(weekSelected);

    //     // 選択したのがAll or 1なら入ってる.
    //     if (weekSelected === UserListField.ALL || userVisitDay[weekIndex] === 1) {
    //       if (parent) {
    //         // 居る人は表示する.
    //         parent.hidden = false;

    //         // 偶数は白/奇数グレー(cssがhidden要素をスキップしてくれないので上書き).
    //         const isEven: boolean = index % 2 === 0;
    //         [].forEach.call(parent.childNodes, (child: Node) =>
    //           (child as HTMLElement).style.background = isEven ? '#fff' : '#e8e4df'
    //         );

    //         index++;
    //       }
    //     } else {
    //       if (parent) {
    //         // 該当しない人は消す.
    //         parent.hidden = true;
    //       }
    //     }
    //   }
    // }
  }

  /**
   * 一覧をクリックしたときの処理.
   *
   * @memberof UserSelectBody
   */
  handleFieldClicked = (userId: string) => {
    window.location.href = `${this.urlBase}/${userId}`;
  }

  array2Link = (array: string[]) => {
    return array.map(val => {
      const url: string = `/hospital/${val}`;
      return <a key="val" href={url}>{val}</a>;
    });
  }

  handleCheckboxChange = (e) => {
    this.setState({download: false});
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (value) {
      this.props.checkedUserIds.push(name);
    } else {
      const removeIndex = this.props.checkedUserIds.indexOf(name);
      this.props.checkedUserIds.splice(removeIndex, 1);
    }
    this.runAPI();
  }

  runAPI() {
    if (this.props.type === Type.Patient) {
      this.props.moffAPIActions.getPatientsDayTrainingLogs(this.props.checkedUserIds);
    }
  }

  /**
   * JSX描画.
   *
   * @returns
   * @memberof UserSelectBody
   */
  render() {
    // 記録.
    // const isKirokuDate: boolean = (this.props.type === Type.Kiroku);
    // const elements: HTMLElement[] = this.refElements;
    let userFields;
    if (this.props.type === Type.Doctor) {
      userFields = this.props.doctors && this.props.doctors.map((user: Doctor, i: number) => {
        return(
          <tr key={user.id} onClick={event => this.handleFieldClicked(user.id)}>
            <td>{user.id}</td>
            <td>{user.username}</td>
            <td>{user.createdAt}</td>
          </tr>
        );
      });
    } else if (this.props.type === Type.Patient) {
      userFields = this.props.patients && this.props.patients.map((user: Patient, i: number) => {
        return(
          <tr key={user.id}>
            <td><input type="checkbox" checked={this.props.checkedUserIds[user.id]} name={user.id} onChange={this.handleCheckboxChange} /></td>
            <td onClick={event => this.handleFieldClicked(user.id)}>{user.username}</td>
            {/* ↓Date型に基づく表記ではないためstringのまま表示する↓ */}
            {/* <td>{user.birthdayYmd}({calcAge(user.birthdayYmd)}歳)</td> */}
            <td onClick={event => this.handleFieldClicked(user.id)}>{user.birthdayYmd}</td>
            <td onClick={event => this.handleFieldClicked(user.id)}>{user.gender === 1 ? UserListField.Male : UserListField.Female}</td>
            {/*
            <td onClick={event => this.handleFieldClicked(user.id)}>{user.hospitalIds && this.array2Link(user.hospitalIds)}</td>
            */}
          </tr>
        );
      });
    } else if (this.props.type === Type.Hospital) {
      userFields = this.props.hospitals && this.props.hospitals.map((user: Hospital, i: number) => {
        return(
          <tr key={user.id} onClick={event => this.handleFieldClicked(user.id)}>
            <td>{user.id}</td>
            <td>{user.name}</td>
            <td>{user.createdAt}</td>
            {/* <td>{user.gender === 0 ? UserListField.Male : UserListField.Female}</td> */}
          </tr>
        );
      });
    }

    return (
      // {}は不要.
      userFields
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserListField.tsx